import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Analytics'i başlat
    analyticsService.initialize();
  }, []);

  useEffect(() => {
    // Sayfa değiştiğinde analytics'e bildir
    analyticsService.trackPageView();
  }, [location.pathname]);

  return {
    trackEvent: analyticsService.trackEvent.bind(analyticsService),
    trackSearch: analyticsService.trackSearch.bind(analyticsService),
    trackCoachView: analyticsService.trackCoachView.bind(analyticsService),
    trackSignUp: analyticsService.trackSignUp.bind(analyticsService),
    trackSignIn: analyticsService.trackSignIn.bind(analyticsService),
    trackContact: analyticsService.trackContact.bind(analyticsService),
    trackCategoryView: analyticsService.trackCategoryView.bind(analyticsService),
    trackError: analyticsService.trackError.bind(analyticsService),
  };
};
